import {
  CubeReducerState,
  CubeStatus,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'Cube/domain/cube.domain.types'

export const getPerformContractExtractionAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  /**
   * Only allow extraction on new, unsaved draft schedules
   */
  if (prevState.data.common.status !== CubeStatus.ScheduleUnsaved) {
    return {
      available: { visible: false, enabled: false },
      reasons: [
        {
          reasonType: DisabledReasonType.InvalidStatus,
          metadata: {}
        }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  }
}
